import React from 'react';

function BlogCards() {
  const blogPosts = [
    {
      id: 1,
      title: "The Future of Web Development in 2025",
      excerpt: "Explore the latest trends and technologies shaping the future of web development, from AI integration to progressive web apps.",
      category: "Development",
      date: "March 15, 2025",
      readTime: "8 min read",
      image: "https://images.unsplash.com/photo-1593720213428-28a5b9e94613?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwyfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NDkwNDAxMjR8MA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Ferenc Almasi", url: "https://unsplash.com/@flowforfrank?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 2,
      title: "Building Scalable Digital Solutions",
      excerpt: "Learn how to architect digital solutions that can grow with your business needs and handle increasing demands efficiently.",
      category: "Business",
      date: "March 12, 2025",
      readTime: "6 min read",
      image: "https://images.unsplash.com/photo-1576267423048-15c0040fec78?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHN1Y2Nlc3N8ZW58MHx8fHwxNzQ5MDQwMTIzfDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Windows", url: "https://unsplash.com/@windows?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 3,
      title: "Customer Service Excellence in Digital Age",
      excerpt: "Discover how modern businesses are leveraging technology to provide exceptional customer experiences and build lasting relationships.",
      category: "Customer Service",
      date: "March 10, 2025",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1556745753-b2904692b3cd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxjdXN0b21lciUyMHNlcnZpY2V8ZW58MHx8fHwxNzQ5MDQwMTI1fDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Patrick Tomasso", url: "https://unsplash.com/@impatrickt?utm_source=makerdevi&utm_medium=referral" }
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Latest Insights</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest trends, tips, and insights from our team of experts
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {post.category}
                  </span>
                </div>
                
                {/* Image Attribution */}
                <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
                  <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                  <span className="hidden drop-shadow-md group-hover/attribution:block">
                    Image on{' '}
                    <a
                      href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#fff', textDecoration: 'none' }}
                    >
                      Unsplash
                    </a>{' '}
                    by{' '}
                    <a
                      href={post.attribution.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#fff', textDecoration: 'none' }}
                    >
                      {post.attribution.name}
                    </a>
                  </span>
                </span>
              </div>
              
              <div className="p-6">
                {/* Meta Information */}
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <span>{post.date}</span>
                  <span className="mx-2">•</span>
                  <span>{post.readTime}</span>
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-green-600 transition-colors duration-200">
                  {post.title}
                </h3>
                
                {/* Excerpt */}
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                
                {/* Read More Link */}
                <button className="text-green-600 hover:text-green-800 font-medium transition-colors duration-200">
                  Read More →
                </button>
              </div>
            </article>
          ))}
        </div>
        
        {/* View All Button */}
        <div className="text-center mt-12">
          <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200">
            View All Articles
          </button>
        </div>
      </div>
    </div>
  );
}

export default BlogCards;